import { render, staticRenderFns } from "./PstkList.vue?vue&type=template&id=730ecb82&scoped=true&"
import script from "./PstkList.vue?vue&type=script&lang=js&"
export * from "./PstkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ecb82",
  null
  
)

export default component.exports